import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { GlobalNamespace as _GlobalNS, environment } from '../../environments/environment';
import { GlobalService } from './../core/global.service';
import { OfferCountItem } from './offer';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
import * as i2 from "../core/global.service";
var OfferServiceService = /** @class */ (function () {
    function OfferServiceService(_http, _global) {
        this._http = _http;
        this._global = _global;
        this.httpOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json'
            })
        };
    }
    OfferServiceService.prototype.getOfferCounter = function () {
        var api = _GlobalNS.api.offer.counter;
        var propertyId = this._global.find(_GlobalNS.paths.PropertyId);
        var url = (environment.production) ? api + "&PropertyId=" + propertyId : api + "?PropertyId=1";
        return this._http.get(url);
    };
    OfferServiceService.prototype.getOffers = function (pagination, loanNumber, offerStatus, loadDefault) {
        var api = _GlobalNS.api.offer.allOffers;
        var params = new HttpParams();
        if (loadDefault) {
            params = params.set('offset', pagination.offset.toString())
                .set('pageSize', pagination.pageSize)
                .set('sortValue', '')
                .set('sortDir', '');
            params = params.set('offerStatus', 'new');
        }
        else {
            params = params.set('offset', pagination.offset.toString())
                .set('pageSize', pagination.pageSize)
                .set('sortValue', pagination.sortValue)
                .set('sortDir', pagination.sortDir);
            if (loanNumber && loanNumber.split(',').length > 0) {
                params = params.set('loanNumber', loanNumber);
            }
            if (offerStatus && offerStatus.length > 0) {
                params = params.set('offerStatus', offerStatus.join(','));
            }
        }
        return this._http.get("" + api, { params: params });
    };
    OfferServiceService.prototype.updateOffer = function (OfferPayload) {
        var api = _GlobalNS.api.offer.updateOffer;
        var eqrf = this._global.find(_GlobalNS.paths.eqrf);
        return this._http.post(api + "&eqrf=" + eqrf, OfferPayload, this.httpOptions);
    };
    OfferServiceService.ngInjectableDef = i0.defineInjectable({ factory: function OfferServiceService_Factory() { return new OfferServiceService(i0.inject(i1.HttpClient), i0.inject(i2.GlobalService)); }, token: OfferServiceService, providedIn: "root" });
    return OfferServiceService;
}());
export { OfferServiceService };
